import $ from 'jquery';
import RevisionMessage from '@/components/contractor/competitions/proposals/modals/revision-message';
import InviteSuppliers from '@/components/contractor/competitions/proposals/modals/invite-suppliers';
import { getTotalOfSentProposalsInCompetition, downloadCompetitionMap, resendInvites } from '@/services';
export default {
    name: 'HeaderProposals',
    props: {
        competitionData: Object,
        proposals: Array,
        suppliers: Array,
        id: String
    },
    components: { RevisionMessage, InviteSuppliers },
    data: () => ({
        totalOfProposalsSent: 0,
        modalRevisionMessage: false,
        modalInviteSuppliers: false,
        showAlert: false,
        message: '',
        colorAlert: ''
    }),
    methods: {
        navegationRouter(url) {
            this.$router.push(url);
        },
        openMenu() {
            $('.dropdown-button').on('click', function(event) {
                console.log('dasudasgd');
                event.preventDefault();
            });
        },
        async resendInvites() {
            console.log(this.suppliers);
            const tokens = this.suppliers.filter(({ status }) => status != 'accepted').map(({ token }) => token);
            if (tokens.length > 0) {
                const data = {
                    competition_id: this.competitionData.id,
                    tokens: tokens
                };
                await resendInvites(data);
                this.showAlert = true;
                this.message = 'Convites reenviados com sucesso.';
                this.colorAlert = 'green';
                setTimeout(() => {
                    this.showAlert = false;
                }, 2000);
            }
        },
        async downloadCompetitionMap() {
            if (parseInt(this.totalOfProposalsSent) > 0) {
                await downloadCompetitionMap(this.id);
            } else {
                this.$emit('no-proposals-sent', true);
            }
        }
    },
    async created() {
        const data = await getTotalOfSentProposalsInCompetition(this.id);
        this.totalOfProposalsSent = data.totalOfProposals;
    }
};
